import { render, staticRenderFns } from "./text_input.vue?vue&type=template&id=08b0a28c"
import script from "./text_input.vue?vue&type=script&lang=js"
export * from "./text_input.vue?vue&type=script&lang=js"
import style0 from "./text_input.vue?vue&type=style&index=0&id=08b0a28c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports